function productsService($q, apiService) {
  this.changeProduct = function(subscriptionId, productId) {
    const url = `/subscriptions/${subscriptionId}/sku_swap/`;
    const data = {
      products: [productId]
    };

    return apiService.put(url, data);
  };
}

productsService.$inject = ['$q', 'apiService'];

module.exports = productsService;
